module.exports = __webpack_public_path__ + "static/img/feature-navigation.b7a3e01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/common/h5/imgs/feature-navigation.png
// module id = 1p9z
// module chunks = 13